var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titlePwa"},[_c('h2',{staticClass:"global-title",domProps:{"innerHTML":_vm._s(_vm.textTitle)}}),(_vm.showMore)?_c('div',{staticClass:"moreBtn",on:{"click":_vm.handleClickMore}},[_c('span',{staticClass:"icon-circle-right"}),_vm._v(_vm._s(_vm.textMore)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }